// @flow
import React, { Component } from "react";
import Helmet from "react-helmet";
import { prettyDate } from "../../utils/helpers";
import config from "../../../data/SiteConfig";
import BreachHero from "./BreachHero/BreachHero";
import BreachInfo from "./BreachInfo/BreachInfo";
import BreachNews from "./BreachNews/BreachNews";
import container from "../../styles/container.module.css";

type Props = {
  breach: PrismicBreach
};

class Breach extends Component<Props, void> {
  render() {
    const { breach } = this.props;
    const { data } = breach;
    const pageDescription = `This security breach was disclosed by ${
      data.company_name
    } on ${prettyDate(data.disclosed_at)}`;
    return (
      <div>
        <Helmet>
          <title>{data.title.text} - Breachroom</title>
          <meta name="description" content={pageDescription} />
          <meta property="og:title" content={data.title.text} />
          <meta property="og:description" content={pageDescription} />
          <meta property="og:url" content={config.siteUrl + breach.uid} />
          <meta name="twitter:image:alt" content={data.title.text} />
        </Helmet>
        <div className={container.default}>
          <BreachHero breach={breach} />
          <BreachInfo breach={breach} />
        </div>
        <BreachNews location={data.location} stories={data.stories} />
      </div>
    );
  }
}

export default Breach;



// WEBPACK FOOTER //
// ./src/components/Breach/Breach.js